import { HttpService } from "./http.service";
import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";

const basePath = "/Event";
const request = HttpService.handleRequest();

export const EventService = {
  getAll,
  getList,
  insert,
  update,
  del,
  getById,
  remove,
  GetBranchesHolidayReferences,
  UpdateBranchesHolidayReferences
};

async function getAll() {
  return request.get(basePath);
}

async function insert(data) {
  return request.post(`${basePath}`, data);
}

async function update(data) {
  return request.put(basePath, data);
}

async function del(data) {
  return request.delete(`${basePath}/DeleteById/${data.id}`);
}

async function remove(data) {
  return request.post(`${basePath}/remove`, data);
}

async function getById(id) {
  return request.get(`${basePath}/${id}`);
}

async function getList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/ListWithPagination`, data);
}

async function GetBranchesHolidayReferences(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/BranchesHolidayReferences`, data);
}

async function UpdateBranchesHolidayReferences(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/UpdateBranchesHolidayReferences`, data);
}
export default EventService;